module.exports = __webpack_public_path__ + "img/From Hanoi to Katowice.880f81d4.png";